import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"line-height":"1.2"} }
const _hoisted_2 = { class: "flex flex-col h-full" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "flex place-content-between my-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined opacity-70" }, "timer ", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-0 -mx-4 mb-3 border-b md:-mx-5" }, null, -1)
const _hoisted_11 = { class: "flex place-content-between items-center mt-auto -mb-1 bg-black bg-opacity-0" }
const _hoisted_12 = {
  key: 0,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_ParticipationThumbnail = _resolveComponent("ParticipationThumbnail")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "md:h-23rem h-64" }, {
      header: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.event.name), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "flex-grow",
            innerHTML: _ctx.event.instructions
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.event.time_limit_rule === _ctx.EventTimeLimitRule.TIME_LIMIT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", null, [
                    (_ctx.event.time_limit_seconds >= 3600)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formattedTime.hours) + ": ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.formattedTime.minutes) + ":" + _toDisplayString(_ctx.formattedTime.seconds), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Tag, { tag: { name: 'Entry Level' } })
                ]))
              : _createCommentVNode("", true)
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_ParticipationThumbnail, { participation: null })
              ]))
            : _createCommentVNode("", true),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isParticipable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    class: "order-12 md:mt-6 xl:mt-0 xl:order-1",
                    to: {
									name: 'ExamParticipationPage',
									params: {
										examId: _ctx.event.id,
										courseId: _ctx.courseId,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, {
                        variant: 'primary',
                        outline: false,
                        size: 'sm'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("student_course_dashboard.begin_exam")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_CopyToClipboard, {
              "icon-only": true,
              tooltip: _ctx.$t('exercise_solution.share'),
              value: _ctx.permalink
            }, null, 8, ["tooltip", "value"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}